import { productDetailsSpecs } from "../../redux/actions";
import { useCallback, useState, useEffect } from "react";

export default function ProductSpec() {
  const [specsData, setSpecsData] = useState({});

  const productDetailsSpec = useCallback(async () => {
    const data = await productDetailsSpecs();

    if (data?.page?.data?.en) {
      setSpecsData(data?.page?.data?.en);
    }
  }, []);

  useEffect(() => {
    productDetailsSpec();
  }, [productDetailsSpec]);

  return (
    <div className="col-lg-3">
      {specsData?.values?.length > 0 ? (
        <div className="product-details__sidebar bg-light-grey border border-gray-100 rounded-16 overflow-hidden">
          <div className="p-24">
            <div className="flex-between bg-main-600 rounded-pill p-8">
              <div className="flex-align gap-8">
                <span className="w-44 h-44 bg-white rounded-circle flex-center text-2xl">
                  <i className="ph ph-storefront" />
                </span>
                <span className="text-white">{specsData?.hero_title}</span>
              </div>
              {/* {specsData?.buttons && (
                                <Link
                                    to={specsData?.buttons[0]?.attributes?.link}
                                    className="btn btn-white rounded-pill text-uppercase"
                                >
                                    View Store
                                </Link>
                            )} */}
            </div>
          </div>
          {specsData?.values?.length > 0 &&
            specsData?.values.map((value) => (
              <div className="p-24  d-flex align-items-start gap-24 border-bottom border-gray-100">
                <span className="w-44 h-44 bg-white icon-color rounded-circle flex-center text-2xl flex-shrink-0">
                  <i className={value?.attributes?.icon} />
                </span>
                <div>
                  <h6 className="text-sm mb-8">{value?.attributes?.title}</h6>
                  <p className="text-gray-700">
                    {value?.attributes?.description}
                  </p>
                </div>
              </div>
            ))}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
